import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-bootstrap/esm/Button.js");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/homepage/customer-service.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/homepage/reviews.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/box-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/caret-solid-right.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/money-back-guarantee-light.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/question-mark.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/repeat-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/star-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/tag-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/dashboard/dashboardItem.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/dashboard/dashboardContent.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/dashboard/dashboard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/dashboard/searchComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/dashboard/topsortBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/highest-quality-brands/highestQualityBrands.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/homePageAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/recently-viewed/homePageRecentlyViewedItems.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/recommended-for-you/homePageProductRecommendations.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/specialities.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/subscribe-success/subscribeSuccessDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/testimonials/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/top-categories/topCategories.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/value-proposition/valueProposition.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/(homepage)/homepage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(homepage)/weekly-specials/weeklySpecialsCountdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyViewedItems"] */ "/app/src/components/recentlyViewedItems/recentlyViewedItems.tsx");
